module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/ISO 45001-2018.74a67dd2.png";